import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const PinLocationAIcon = ({
  size = '24px',
  primaryColor = COLORS.kinetikBlack,
  secondaryColor = COLORS.white,
  sx = {},
  ...props
}) => (
  <SvgIcon sx={{ width: size, height: size, ...sx }} {...props}>
    <path
      fill={secondaryColor}
      d="M12 1.58a7.5 7.5 0 0 0-7.5 7.5c0 4.25 4.719 10.522 6.67 12.933.43.53 1.23.53 1.66 0C14.78 19.601 19.5 13.33 19.5 9.08a7.5 7.5 0 0 0-7.5-7.5Z"
    />
    <path fill={primaryColor} d="M12.555 9.64h-1.11l.553-1.791.557 1.792Z" />
    <path
      fill={primaryColor}
      fillRule="evenodd"
      d="M12 3.58a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-.497 3L9.75 11.455h1.132l.3-.97h1.634l.302.97h1.132L12.491 6.58h-.988Z"
      clipRule="evenodd"
    />
    <path
      fill={primaryColor}
      fillRule="evenodd"
      d="M12.36 2.089A7 7 0 0 1 19 9.08l-.013.377c-.26 3.951-4.447 9.514-6.213 11.694l-.079.087a.994.994 0 0 1-1.39 0l-.08-.087C9.405 18.901 5 13.046 5 9.081a7 7 0 0 1 7-7l.36.008Zm-.36.97A6.02 6.02 0 0 0 5.98 9.08c0 1.696.97 3.95 2.292 6.179 1.295 2.182 2.817 4.167 3.714 5.275l.006.006.002.001.006.001.006-.001.002-.001.005-.006c.897-1.108 2.42-3.093 3.714-5.275 1.322-2.229 2.293-4.483 2.293-6.179A6.02 6.02 0 0 0 12 3.06Z"
      clipRule="evenodd"
    />
  </SvgIcon>
);

PinLocationAIcon.propTypes = {
  size: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  sx: PropTypes.object,
};

export default PinLocationAIcon;
